import { Component, OnInit } from '@angular/core';
import { Router,ActivatedRoute } from '@angular/router';
import { HotelService } from '../services/hotel.service';

import { Location } from '@angular/common';
declare var $:any;
@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.css']
})
export class NavbarComponent implements OnInit {
  title = 'Tejashree Enterprises';

  title1:any;
  loggedIn = false;
  public href: string = "";
  constructor(location: Location,private activatedRoute:ActivatedRoute,private router:Router,private hotelService: HotelService) {
    router.events.subscribe((val) => {
      if(location.path() != ''){
        this.href = location.path();
      } else {
        this.href = 'home'
      }
    });
  //console.log(router.location.path())
}


  ngOnInit() {
    //this.setActive();
    this.href = this.router.url;
    var str = window.location.pathname;
    var res = str.substr(1, 20);
    //var Stringss=str.substring(str.indexOf("/")+1,str.lastIndexOf("/"));
    // console.log(res);

    if(localStorage.getItem('currentUser') === null)
    {
      this.loggedIn = false;
    }
    else
    {
      this.loggedIn = true;
    }
  }

  setActive(menu) {

    $('li').removeClass();
    $('#'+menu).addClass("active");
  }
    
    
}



// WEBPACK FOOTER //
// D:/xampp/htdocs/tejashree/src/app/navbar/navbar.component.ts